// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import iView from 'view-design'
import i18n from '@/locale'
import config from '@/config'
import importDirective from '@/directive'
import { directive as clickOutside } from 'v-click-outside-x'
import installPlugin from '@/plugin'
import './index.less'
import '@/assets/icons/iconfont.css'
import TreeTable from 'tree-table-vue'
import VOrgTree from 'v-org-tree'
import 'v-org-tree/dist/v-org-tree.css'
import WebTableColumnsModal from '@/view/components/web-table-columns-modal'
import ContextMenu from '@/view/components/context-menu'
import echarts from 'vue-echarts/components/ECharts.vue'

import {
  AsAlarmType,
  AlarmLevel,
  AlarmInfoState,
  DsmAlarmInfoAlarmType,
  AdasAlarmInfoAlarmType,
  AdasAlarmInfoDeviateType,
  AdasAlarmInfoSignType,
  BsdAlarmInfoAlarmType,
  TpmsAlarmInfoAlarmType,
  HasBindServiceDevicesType
} from '@/enum/status-list'

Date.prototype.Format = function (fmt) { // author: meizz
  var o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    'S': this.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) { fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length)) }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) { fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))) }
  }
  return fmt
}

// import 'view-design/dist/styles/iview.css'

Vue.use(iView, {
  i18n: (key, value) => i18n.t(key, value)
})
Vue.use(TreeTable)
Vue.use(VOrgTree)
Vue.component('chart', echarts)
Vue.component('web-table-columns-modal', WebTableColumnsModal)
Vue.component('context-menu', ContextMenu)

/**
 * @description 注册admin内置插件
 */
installPlugin(Vue)
/**
 * @description 生产环境关掉提示
 */
Vue.config.productionTip = false
/**
 * @description 全局注册应用配置
 */
Vue.prototype.$config = config
/**
 * 注册指令
 */
importDirective(Vue)
Vue.directive('clickOutside', clickOutside)

Vue.prototype.AsAlarmType = AsAlarmType
Vue.prototype.AlarmLevel = AlarmLevel
Vue.prototype.AlarmInfoState = AlarmInfoState
Vue.prototype.DsmAlarmInfoAlarmType = DsmAlarmInfoAlarmType
Vue.prototype.AdasAlarmInfoAlarmType = AdasAlarmInfoAlarmType
Vue.prototype.AdasAlarmInfoDeviateType = AdasAlarmInfoDeviateType
Vue.prototype.AdasAlarmInfoSignType = AdasAlarmInfoSignType
Vue.prototype.BsdAlarmInfoAlarmType = BsdAlarmInfoAlarmType
Vue.prototype.TpmsAlarmInfoAlarmType = TpmsAlarmInfoAlarmType
Vue.prototype.HasBindServiceDevicesType = HasBindServiceDevicesType

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  render: h => h(App)
})
